import { configureStore } from "@reduxjs/toolkit";
import user from "./reducers/reducer.user";

const store = configureStore({
  reducer: {
    user,
  },
});

export default store;
